import { memo, useEffect, useRef, useState, ReactNode } from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
  portalId: string;
  children: ReactNode;
}

const Template = ({ portalId, children }: PortalProps) => {
  const el = useRef(document.getElementById(portalId) || document.createElement('div'));
  const [needNewParentNode] = useState(!el.current.parentElement);

  useEffect(() => {
    // check if there is no current parent on portal element and if no -> create new DOM Node
    if (needNewParentNode) {
      el.current.id = portalId;
      document.body.appendChild(el.current);
    }

    return () => {
      if (needNewParentNode && el.current.parentElement) {
        el.current.parentElement.removeChild(el.current);
      }
    };
  }, [portalId]);

  return createPortal(children, el.current);
};

export const Portal = memo(Template);
